import React from 'react';
export function PenIcon(colorIcon = '#0b6674') {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill={colorIcon}
            d="M13.75,7,10,3.25l-10,10V17H3.75Zm3-3a1,1,0,0,0,0-1.41L14.37.29A1,1,0,0,0,13,.29l-2,2L14.75,6Z"
          />
        </g>
      </g>
    </svg>
  );
}
